/**
 * Convert the date from this format '1382022584306+120' to a date on local timezone.
 * 
 * @param dateStr
 * @returns {Date}
 */
function getLocalTimeZoneDate(dateStr) {
	var sign = (dateStr.indexOf("-") != -1 ? "-" : "+");
	var splitDate = dateStr.split(sign);
	var offsetMin = (sign == '+' ? -1 : 1) * splitDate[1];
	var	date = new Date(+splitDate[0]);
	date.setMinutes(date.getMinutes() + offsetMin);
	return date;
}


/**
 * Convert the date from Date to a pretty date string
 * 
 * @param date
 * @returns
 */
function prettyDate(date){
	var dateSeconds  = Math.round(date.getTime()/1000.0);       // date in seconds since 1970/01/01
	var nowSeconds   = Math.round(new Date().getTime()/1000.0); // now in seconds since 1970/01/01
	var deltaSeconds = nowSeconds - dateSeconds;
	switch(true) {
		case(deltaSeconds <= 1): return JUST_NOW; break;
		case(deltaSeconds < 30): return deltaSeconds + " " + SECONDS_AGO; break;
		case(deltaSeconds < 40): return HALF_A_MINUTE_AGO; break;
		case(deltaSeconds < 60): return LESS_THAN_A_MINUTE_AGO; break;
		case(deltaSeconds < 90): return "1 " + MINUTE_AGO; break;
		case(deltaSeconds < 100): return "1 " + MINUTE_AND_A_HALF_AGO; break;
		case(deltaSeconds < 60*60): return Math.round(deltaSeconds / 60) + " " + MINUTES_AGO; break;
		case(deltaSeconds < 60*60*1.5): return "1 " + HOUR_AGO; break;
		case(deltaSeconds < 60*60*24): return Math.round(deltaSeconds / 60 / 60) + " " + HOURS_AGO; break;
		case(deltaSeconds < 60*60*24*1.5): return "1 " + DAY_AGO; break;
		case(deltaSeconds < 60*60*24*7): return Math.round(deltaSeconds / 60 / 60 / 24) + " " + DAYS_AGO; break;
		case(deltaSeconds < 60*60*24*7*1.5): return "1 " + WEEK_AGO; break;
		case(deltaSeconds < 60*60*24*7*4): return Math.round(deltaSeconds / 60 / 60 / 24 / 7) + " " + WEEKS_AGO; break;
		case(deltaSeconds < 60*60*24*7*4*1.5): return "1 " + MONTH_AGO; break;
		case(deltaSeconds < 60*60*24*7*4*12): return Math.round(deltaSeconds / 60 / 60 / 24 / 7 / 4) + " " + MONTHS_AGO; break;
		case(deltaSeconds < 60*60*24*7*4*12*1.5): return "1 " + YEAR_AGO; break;
		default: return date.toLocaleString();
	}
}

/**
 * Refresh all element in timestamp classname, with a pretty date value.
 * 
 * @param node optionals, refresh all pretty date into the node or in all body document if node is undefined.
 */
function refreshPrettyDateIntoPage(nodeParam) {
	var node = !isDefined(nodeParam) ? document.getElementsByTagName("body")[0] : nodeParam;
	$(node).find('abbr.pydata').each(function( index ) {
		try {
			var dateStr = this.getAttribute('data');
			
			var localTZData = getLocalTimeZoneDate(dateStr);
			
			if (localTZData != 'Invalid Date') {
				var prettyData = prettyDate(localTZData);
				this.innerHTML = prettyData;
			}
			else {
				this.innerHTML = this.getAttribute('title');
			}
		}
		catch (e) {
			this.innerHTML = this.getAttribute('title');
		}
	});
}

// to check if pretty date running
var isRunning = false;

/**
 * Start pretty date refreshing
 * 
 * @param refreshIntervalSeconds interval seconds to repeat refresh action
 * @param id interval id of an already running interval
 * @returns
 */
function startPrettyDate(refreshIntervalSeconds, id) {
	if (isRunning) {
		return id;
	}
	else {
		isRunning = true;
		return setInterval( "refreshPrettyDateIntoPage()", refreshIntervalSeconds*1000 );
	}
}

/**
 * Stop pretty date refreshing.
 * 
 * @param id interval id to stop
 */
function stopPrettyDate(id) {
	if (isRunning) {
		clearInterval(id);
		isRunning = false;
	}
}
